export const TOS_VERSION = "2026-02-11";

const TermsOfServiceText = () => {
  return (
    <div className="m-2 flex flex-col gap-1">
      <h3 className="text-brand-neutral-black text-base font-bold text-center">
        Venturous Terms of Service
      </h3>
      <ol className="pl-6 space-y-3 text-brand-neutral-black list-decimal">
        <li>
          By creating an account at{" "}
          <a href="http://app.venturous.work">http://app.venturous.work</a> (the
          “Website”) or accessing or using our Services (described below)
          (whether or not you have registered), you are agreeing to enter into a
          legally binding contract (on the terms outlined in these Terms of
          Service) with Varsity Labs, Inc., a Delaware corporation, doing
          business as Venturous (“Venturous”, the “Company,” or “We”). If you
          are registering an account on behalf of the organization you work for
          or represent, by registering such account, you represent and warrant
          to us that you have the authority to bind your organization to these
          Terms of Service and agree that such organization will be bound
          hereby. If you do not agree to these Terms of Service, do not create
          an account or access or otherwise use any of our Services.
        </li>
        <li>
          Our services involve the sharing of information among users of our
          Website. For example, individual professionals may register for a
          Website account and access our Website to identify organizational
          users at which they may desire to be placed as contractors or
          employees on a part-time (fractional) or full-time basis. Such
          individuals are referred to herein as “candidates.” Others may
          register as representatives of organizations seeking to identify
          candidates willing and able to provide needed skills to the
          organizations they represent on the same basis. Such individuals are
          referred to herein as “representatives.” “Services”, as such term is
          used herein, includes the facilitating the matching of candidates with
          organizations as described above as well as any facilitation provided
          by Venturous to candidates and representatives that have matched with
          each other via the Website and desire to engage in an exchange of
          services for payment, whether on a fractional or full-time basis, and
          whether as an employee or contractor. These Terms of Service apply to
          our Website, all functionality provided by us through the Website, all
          facilitation provided by Venturous to candidates, representatives and
          organizations that have matched via the Website (whether or not
          provided through the Website), and any related apps, communications,
          or other services that we provide that refer to these Terms of
          Services.
        </li>
        <li>
          By registering for an account as a candidate or a representative, you
          agree that the information you provide about yourself and, in the case
          of representatives, about your organization, may be shared with other
          users of the Services. In the case of candidates this includes, for
          example, the information you provide about yourself that might be
          found on your professional resume or any third party website to which
          you provide a link and that contains information about you. In the
          case of representatives, this includes, for example, the information
          you provide about your organization and the positions it is seeking to
          fill, including information contained on any such organization’s
          website or any third party website containing information about such
          organization to which you provide us with a link. For the avoidance of
          doubt, these Terms of Service apply equally to both candidates and
          representatives when accessing the Website or making of use of our
          Services unless otherwise specified.
        </li>
        <li>
          In the case of candidates, you are responsible for evaluating and
          determining the suitability of any project or engagement proposed by a
          representative. Representatives are responsible for evaluating and
          determining the suitability of any candidate for any project or
          engagement with the organization such representative represents. In
          either case, you acknowledge and agree that (i) Venturous is not a
          hiring entity, an agent of any candidate or organization represented
          by a representative, or an employer of candidates; (ii) Venturous does
          not guarantee that any candidate will be available or willing to
          provide services to your organization; (iii) Venturous is not a party
          to the relationship or any dealings between candidates and a
          representative or the organization they represent. Candidates (whether
          they are individuals or entities) are solely responsible for (i)
          determining which projects to accept; (ii) the time, place, and manner
          of providing any services and (iii) the price they charge for their
          services. Without limiting the foregoing, Venturous is not responsible
          for supervising the services to be performed by a candidate. Each user
          agrees to look exclusively to the other user involved in the event a
          user is not satisfied with such user’s performance of any agreement as
          to the services to be provided by a candidate (including, without
          limitation, quality or similar issues) or amounts to be paid to such
          candidate in consideration of such services. In no event shall any
          such issues arising be deemed to require a refund by Venturous of any
          previously paid Fees.
        </li>
        <li>
          Venturous Fees and Candidate Payments:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              For any agreement entered into between a candidate and an
              organizational user, Venturous collects a fee in the form of a
              markup on the total fees invoiced or otherwise payable to the
              candidate for the services he or she have agreed to provide (the
              “Fees”). In the event that an organization seeks to directly
              engage a candidate on a permanent basis, the markup will be a
              percentage of the annual compensation payable to the candidate,
              including bonuses and any other cash compensation (the “Conversion
              Fee”), which shall be payable within 45 days of the candidate’s
              start date. The amount of the markup in both cases is set forth on
              {/* TODO: Anchor the sup */}
              our Schedule of Fees<sup>1</sup>. All such Fees are charged by
              Venturous through the Platform in accordance with the payment
              instructions provided when you registered your account.
            </li>
            <li>
              For ongoing services, candidates will invoice the organizations
              for which they are working through the Website. All parties to
              such transactions agree that Venturous may refer to such invoices
              for purposes of verifying the amount of the Fees payable by the
              applicable organization for such candidate’s services.
            </li>
            <li>
              Venturous’ Fees are deemed to have accrued and be fully earned
              upon the submission of the candidate’s invoice and all parties
              agree that at such time Venturous may automatically charge the
              organization’s user’s current form of payment on file in the
              amount of the Fees due. Venturous may also pass through any
              payment processing fees.
            </li>
            <li>
              Users will cause all payments due to a candidate to be processed
              through the functionality provided on the Website, which
              functionality is provided by a third party payment processor
              (“Processor”). Users agree to abide by the terms and conditions
              promulgated by such Processor. Venturous reserves the right to
              substitute a new Processor from time to time, upon notice as
              outlined here.
            </li>
            <li>
              Users agree not to deal with each other directly or otherwise
              attempt to circumvent the Website or Venturous in order to avoid
              paying Venturous the Fees owing hereunder. In the event any such
              circumvention is identified, both parties will be jointly and
              severally responsible for all Fees accruing and not paid hereunder
              together with interest on any missed Fees from the date such Fees
              were originally due at a rate of 25% per annum or the maximum rate
              allowed by law, if less. The parties agree that Venturous will
              also be entitled to recover its reasonable costs of collection,
              including attorneys’ fees and court costs, if Venturous is
              required to bring an action to collect any unpaid Fees due
              hereunder.
            </li>
          </ol>
        </li>
        <li>
          As a user of our Services, the collection, use and sharing of your
          personal data is subject to our Privacy Policy. By using our Services,
          you agree to the Privacy Policy. You acknowledge that the Privacy
          Policy describes how we may use your information in connection with
          artificial intelligence in connection with providing the Services.
        </li>
        <li>
          We may modify these Terms of Service and our Privacy Policy from time
          to time. If required by applicable law, we will provide you with
          notice through our Services or by other means to provide you with the
          opportunity to review the changes before they become effective. If you
          object to any such changes, your sole remedy is to delete your account
          and cease all use of the Services. Your continued use of our Services
          after the effective date of any change in these Terms of Service or
          Privacy Policy means you have consented to such changes as of their
          effective date.
        </li>
        <li>You must be 18 years of age to use our Services.</li>
        <li>
          You agree not to register for more than one account with us, which
          must be in your real name. Creating an account with or otherwise
          providing false information to us or others via the Services is a
          violation of these Terms of Service and may result in the deletion of
          your account and other legal action.
        </li>
        <li>
          You agree to protect your account from unauthorized access by others
          and will not share or transfer your account. You are responsible for
          anything that happens through your account.
        </li>
        <li>
          Your account is a license to use our Services. Except as to content
          which you submit or post, which is addressed below, the account is not
          your property. We may terminate your account for any reason at any
          time. You agree that if we do so, we will not owe you anything for
          your account.
        </li>
        <li>
          We may notify you regarding the Services (i) within the Services
          (e.g., on the Website) and/or (ii) via the contact information you
          provided when you registered. You agree to keep your contact
          information up to date.
        </li>
        <li>
          As between Venturous and you (or the organization you represent, in
          the case of representatives), you own (and are responsible for the
          accuracy and completeness of) the content you submit or post to the
          Services. By submitting or posting such information, you grant us and
          our affiliates a non-exclusive, worldwide, transferable and
          sublicensable right to use, copy, modify, distribute, publicly perform
          and display, host, and process your content and other information
          without any further consent, notice and/or compensation to you or
          others, for any lawful purpose, subject to the Privacy Policy and the
          following. You can terminate the foregoing license by deleting the
          applicable content or closing your account, except to the extent (i)
          the content has been accessed via the Services by others (who may have
          downloaded or separately made or stored a copy), (ii) we are required
          by law to retain or share such content with others, (iii) to carry out
          the purposes and exercise the rights listed in these Terms of Service
          and/or the Privacy Policy, and (iv) as part of our standard archival
          processes. By submitting or posting such content, you represent and
          warrant that such content is complete and accurate and that you have
          the right to submit or post such content and that doing so will not
          violate the rights (including intellectual property rights) of any
          third party. We do not commit to retain any content or other
          information you have provided to us, except as may be required by law
          or in order to comply with the Privacy Policy. Using the features of
          our Services, candidates may elect to edit or delete information they
          choose to share via the Services at any time. Candidates may also
          elect to hide their profile and information from searches performed by
          other users generally (for example, when not actively seeking a
          position) or by listing specific organizations with which your profile
          and information should not be shared. Notwithstanding the foregoing,
          filtering features can be an imprecise science, and Venturous is not
          responsible if your profile appears in a search by a current or former
          employer or any other organization you may not want to know that you
          are actively seeking staffing opportunities.
        </li>
        <li>
          We do not control the accuracy or completeness of information or
          content submitted or posted by others. We are not responsible to you
          if you or the organization you represent suffers any damage or
          liability in the event information or content submitted to Venturous
          by another user proves to have been inaccurate or incomplete, whether
          or not we were aware or could have determined such inaccuracy or
          incompleteness through an investigation. Venturous has no obligation
          to independently verify the information or content submitted or posted
          by users (but reserves the right to do so without obligation to other
          users).
        </li>
        <li>
          We may change, suspend or discontinue any of our Services at any time
          without prior notice. We may also limit the availability of features,
          content and other information so that they are not available to all
          users.
        </li>
        <li>
          Subject to your rights in the content you submit or post, we retain
          all rights, title and interest in and to all intellectual property
          rights in the Services and our Website.
        </li>
        <li>
          You agree to comply with all applicable laws when accessing and using
          the Services, including, without limitation, privacy laws,
          intellectual property laws, anti-spam laws, export control laws, and
          other applicable law.
        </li>
        <li>
          You will not use the Services to market third party products or
          services to other users. The Services are intended as a marketplace
          for candidates to be matched with the organizations representatives
          represent. Any other use by a user not approved in advance by
          Venturous is strictly prohibited. Any violation of the foregoing may
          result in the immediate suspension and/or deletion of your account and
          further legal action.
        </li>
        <li>
          If as part of the Services you are required to pay any amounts to
          Venturous (for example, Fees for facilitating the connection with a
          candidate who is providing services to your organization), the
          following terms apply:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              You agree to pay all applicable amounts and all taxes and other
              charges imposed by any governmental agency accruing in respect of
              such payments. You agree that we may calculate the taxes owed
              based on the address you provided with your billing information.
            </li>
            <li>
              You agree that we may store the billing information you provide
              and/or share such information with a third party with which
              Venturous may have contracted to facilitate payments in connection
              with the Services. You agree to keep your payment information
              updated at all times. Failure to do so may result in a disruption
              to your access to the Services.
            </li>
            <li>You agree that we may change our prices at any time.</li>
            <li>
              If you purchase a subscription Service or other Services for which
              recurring fees apply, you agree that we may automatically charge
              your form of payment at the start of each applicable billing
              period at the price then in effect unless and until you have
              terminated such Services through the account management features
              of the Services.
            </li>
          </ol>
        </li>
        <li>
          If as part of the Services you are required to pay any amounts to
          another user (for example, a candidate who has agreed to provide
          services to the organization for which you have registered as a
          representative), the following terms apply:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              You agree to pay all applicable amounts via the Website payment
              functionality.
            </li>
            <li>
              You further agree to pay all taxes and other charges imposed by
              any governmental agency accruing in respect of such payments.
            </li>
            <li>
              You agree that you are solely responsible for withholding and
              remitting to the proper governmental authority any taxes or other
              fees required to be withheld and remitted to such authority in
              connection with the payments you are making.
            </li>
            <li>
              You agree that we may store the billing information you provide
              and/or share such information with a third party with which
              Venturous may have contracted to facilitate payments in connection
              with the Services. You agree to keep your payment information
              updated at all times. Failure to do so may result in a disruption
              to your access to the Services.
            </li>
          </ol>
        </li>
        <li>
          If as part of the Services you are receiving payments (for example, in
          exchange for services provided to an organization that has registered
          for the Services via a representative), the following terms apply:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              You agree that all amounts payable to you will be directly
              credited via ACH to the account you specified when you registered
              or later updated via the account management features of the
              Services.
            </li>
            <li>
              You agree that Venturous is not responsible to pay you for any
              services provided to an organization unless Venturous has actually
              received payment from the organization of such amounts for the
              express purpose of further remitting such funds to you. Venturous
              is further released from any such funding obligation if any such
              funds are reversed or clawed back by the funding source.
            </li>
            <li>
              You agree amounts may be withheld from any such payments to the
              extent required by applicable law.
            </li>
            <li>
              You agree that to the extent any amounts are deposited to your
              account in error, your account may be automatically debited to the
              extent necessary to correct such error.
            </li>
            <li>
              You agree that you are solely responsible for the payment of all
              income and other taxes that may accrue in respect of your receipt
              of such amounts except to the extent any such taxes have been
              withheld by the funding party (in which case the funding party
              shall be responsible for remitting such withheld amounts to the
              applicable taxing authority on your behalf).
            </li>
            <li>
              You agree that your provision of the services to the organization
              is done exclusively in the position of an independent contractor
              or employee of such organization (as agreed to be between you and
              such organization) and not as an employee or contractor of
              Venturous. In the absence of an express agreement to the contrary,
              your relationship with any such organization will be that of an
              independent contractor. You agree that neither your participation
              in the Services nor receipt of any payments through Venturous will
              be deemed to establish an employee/employer or independent
              contract relationship between you on the one hand and Venturous on
              the other hand, nor does it qualify you for any benefits provided
              by Venturous to its respective employees.
            </li>
          </ol>
        </li>
        <li>
          You agree not to do any of the following in connection with your use
          of the Services:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              Create a false identity, misrepresent your identity, or
              misrepresent or provide false information about yourself
              (including, in the case of candidates, with respect to your
              qualifications and experience) or the organization you represent,
              if a representative (which includes misrepresenting your authority
              to represent the organization you listed in your registration);
            </li>
            <li>
              Develop, support or use software, devices, scripts, robots or any
              other means or processes (such as crawlers, browser plugins and
              add-ons or any other technology) to scrape or copy any part of the
              Services, including profiles and information of users and other
              data from the Services;
            </li>
            <li>
              Override any security feature or bypass or circumvent any access
              controls or use limits of the Services (such as search results,
              profiles, or videos);
            </li>
            <li>
              Copy, use, display or distribute any information (including
              content) obtained from the Services, whether directly or through
              third parties (such as search tools or data aggregators or
              brokers), without the consent of Venturous;
            </li>
            <li>
              Disclose information that you do not have the consent to disclose
              (such as confidential information of others (including your
              current employer or the organization you represent in the case of
              representatives);
            </li>
            <li>
              Violate the intellectual property rights of others, including
              copyrights, patents, trademarks, trade secrets or other
              proprietary rights;
            </li>
            <li>
              Violate the intellectual property or other rights of Venturous;
            </li>
            <li>
              Post (or otherwise share) anything that contains software viruses,
              worms, or any other harmful or malicious code;
            </li>
            <li>
              Reverse engineer, decompile, disassemble, decipher or otherwise
              attempt to derive the source code for the Services or any related
              technology that is not open source;
            </li>
            <li>
              Imply or state that you are affiliated with or endorsed by
              Venturous without our express consent;
            </li>
            <li>
              Rent, lease, loan, trade, sell/re-sell or otherwise monetize the
              Services or related data or access to the same, without Venturous’
              consent;
            </li>
            <li>
              Deep-link to our Services for any purpose other than to promote
              your profile, without Venturous’ consent;
            </li>
            <li>
              Use bots or other unauthorized automated methods to access the
              Services;
            </li>
            <li>
              Engage in “framing”, “mirroring”, or otherwise simulating the
              appearance or function of the Services;
            </li>
            <li>
              Overlay or otherwise modify the Services or their appearance;
            </li>
            <li>
              Interfere with the operation of, or place an unreasonable load on,
              the Services (e.g., spam, denial of service attack, viruses,
              manipulating algorithms);
            </li>
            <li>
              Use our Services to do anything that is unlawful, misleading,
              discriminatory, or fraudulent.
            </li>
          </ol>
        </li>
        <li>
          If you provide us with a link or other routing information concerning
          any third party service containing information about you (or the
          organization you represent) (for example, to your profile on LinkedIn
          or any similar website), you agree that we may access such third party
          service and the information contained therein about you and use such
          information to provide the Services, including making such information
          available to others via the Services, in all cases subject to our
          compliance with the terms of use imposed by such third party service.
          You agree that we do not control any such third party’s services or
          the accuracy of any information obtained from such third parties.
        </li>
        <li className="font-bold">
          DISCLAIMERS AND LIMITATIONS OF LIABILITY:
          <ol className="pl-6 list-[lower-alpha]">
            <li>
              VENTUROUS AND ITS AFFILIATES MAKE NO REPRESENTATION OR WARRANTY
              ABOUT THE SERVICES, INCLUDING ANY REPRESENTATION THAT THE SERVICES
              WILL BE UNINTERRUPTED OR ERROR-FREE, AND PROVIDE THE SERVICES
              (INCLUDING CONTENT AND INFORMATION) ON AN “AS IS” AND “AS
              AVAILABLE” BASIS. TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE
              LAW, VENTUROUS AND ITS AFFILIATES DISCLAIM ANY IMPLIED OR
              STATUTORY WARRANTY, INCLUDING ANY IMPLIED WARRANTY OF TITLE,
              ACCURACY OF DATA, NON-INFRINGEMENT, MERCHANTABILITY OR FITNESS FOR
              A PARTICULAR PURPOSE.
            </li>
            <li>
              TO THE FULLEST EXTENT PERMITTED BY LAW, VENTUROUS, INCLUDING ITS
              AFFILIATES, WILL NOT BE LIABLE IN CONNECTION WITH THE SERVICES OR
              THESE TERMS OF SERVICE FOR LOST PROFITS OR LOST BUSINESS
              OPPORTUNITIES, DAMAGE TO REPUTATION (E.G., OFFENSIVE, DEROGATORY,
              OR DEFAMATORY STATEMENTS), LOSS OF EMPLOYMENT OR OTHER VALUABLE
              RELATIONSHIPS, LOSS OF DATA (E.G., DOWN TIME OR LOSS, USE OF, OR
              CHANGES TO, YOUR INFORMATION OR CONTENT), OR ANY INDIRECT,
              INCIDENTAL, CONSEQUENTIAL, SPECIAL OR PUNITIVE DAMAGES. VENTUROUS
              AND ITS AFFILIATES WILL NOT BE LIABLE TO YOU IN CONNECTION WITH
              THIS CONTRACT FOR ANY AMOUNT THAT EXCEEDS (A) THE TOTAL FEES PAID
              OR PAYABLE BY YOU TO VENTUROUS FOR THE SERVICES, IF ANY, OR (B) US
              $500. THE LIMITATIONS OF LIABILITY IN THIS SECTION ARE PART OF THE
              BASIS OF THE BARGAIN BETWEEN YOU AND VENTUROUS AND SHALL APPLY TO
              ALL CLAIMS OF LIABILITY (E.G., WARRANTY, TORT, NEGLIGENCE,
              CONTRACT AND LAW) EVEN IF VENTUROUS OR ITS AFFILIATES HAVE BEEN
              TOLD OF THE POSSIBILITY OF ANY SUCH DAMAGE, AND EVEN IF THESE
              REMEDIES FAIL THEIR ESSENTIAL PURPOSE. THESE LIMITATIONS OF
              LIABILITY DO NOT APPLY TO LIABILITY FOR DEATH OR PERSONAL INJURY
              OR FOR FRAUD, GROSS NEGLIGENCE OR INTENTIONAL MISCONDUCT BY
              VENTUROUS. FOR THE AVOIDANCE OF DOUBT, VENTUROUS IS NOT
              RESPONSIBLE FOR ANY OF THE FOREGOING TO THE EXTENT THE RESULT OF
              ANY ACT OR OMISSION OF A USER.
            </li>
          </ol>
        </li>
        <li>
          These Terms of Service (and our contract formed hereby), and any
          dispute arising between us and you (and any organization you represent
          in the case of a representative), are governed by the laws of the
          State of Delaware, excluding its conflicts of law provisions. Any and
          all claims and disputes arising out of our Services or these Terms of
          Service or the Privacy Policy will be litigated only in the federal or
          state courts located in New Castle County, Delaware. By registering
          for an account or accessing or using the Website or our Services, you
          consent to the personal jurisdiction of such courts and waive any
          objection on the basis that such courts are inconvenient or lack
          personal jurisdiction over you or the organization you represent in
          the case of representatives.
        </li>
        <li>
          If a court with authority over our agreement finds any part of these
          Terms of Service or the Privacy Policy is unenforceable, you and we
          agree that the court should modify the terms to make that part
          enforceable while still achieving its intent. If the court cannot do
          that, you and we agree to ask the court to remove that unenforceable
          part and still enforce the rest of these Terms of Service and the
          Privacy Policy.
        </li>
        <li>
          If we don’t act to enforce a breach of these Terms of Service, that
          does not mean that Venturous has waived its right to enforce these
          Terms of Service. You may not assign or transfer your rights hereunder
          (or as to your account or use of Services) to anyone without our
          consent. However, you agree that we may assign our rights and
          obligations to our affiliates or a party that buys them without your
          consent. There are no third-party beneficiaries to these Terms of
          Service or the Privacy Policy.
        </li>
        <li>
          If you delete your account (or your account is deleted) or you suspend
          or ceased to use the Services (or we suspend or terminate your
          access), these Terms of Service and the Privacy Policy will continue
          to apply as to rights and obligations that by their nature should
          survive the termination of our relationship with you (including,
          without limitation, provisions respecting the ownership of
          intellectual property, disclaimers, and limitations of liability).
        </li>
        <li>
          Except to the extent we have signed a separate written agreement with
          you (or your organization, if you are a representative), these Terms
          of Service, together with the Privacy Policy, form the entire
          agreement between us regarding the Services, and together supersede
          all prior agreements. If we have signed a separate written agreement
          with you (or your organization), such agreement controls over these
          Terms of Service and the Privacy Policy to the extent of any conflict
          between them, but to the extent not in conflict, these Terms of
          Service and our Privacy Policy still apply.
        </li>
        <li>
          If you believe any content posted or submitted by another user
          violates your rights (including rights of privacy or intellectual
          property rights) or otherwise violates these Terms of Service, please
          contact us at{" "}
          <a href="mailto:privacy@venturous.work">privacy@venturous.work</a>.
        </li>
        <li>
          The only way to provide legal notice to us is at the following address
          in writing:
          <br />
          Venturous
          <br />
          PO Box 50649
          <br />
          Nashville, TN 37205-0649
          <br />
          United States <br />
          Attn: Legal
        </li>
      </ol>
    </div>
  );
};

export default TermsOfServiceText;
